import classNames from "classnames";
import React, { PureComponent } from "react";

import {
  flexDirectionClass,
  groupInnerClass,
  IStyleColor,
  IStyleFlexDirection,
  IStyleInnerBorder,
  IStyleInnerMargin,
  IStyleInnerPadding,
  IStylePadding,
  IStyleSize,
  IStyleTheme,
  paddingClass,
} from "../../Style";

type TColor = "primary" | "secondary";
type TTheme = "solid" | "border" | "clean";

type Styles = IStyleSize &
  IStyleColor<TColor> &
  IStyleTheme<TTheme> &
  IStyleFlexDirection &
  IStylePadding &
  IStyleInnerMargin &
  IStyleInnerPadding &
  IStyleInnerBorder;

export interface ITabListStyledProps extends Partial<Styles> {
  className?: string;
}

export function getStyledProps(props: Partial<ITabListStyledProps> = {}) {
  const { color, direction, theme, padding, size, className, innerBorder, innerMargin, innerPadding } = props;
  return {
    color,
    direction,
    theme,
    padding,
    size,
    className,
    innerBorder,
    innerMargin,
    innerPadding,
  };
}

export class TabListStyled extends PureComponent<ITabListStyledProps> {
  static defaultProps: Partial<ITabListStyledProps> = {
    color: "primary",
    direction: "row",
    size: "md",
    theme: "border",
  };

  render() {
    const { children, className, color, direction, size, theme, padding, innerBorder, innerMargin, innerPadding } =
      this.props;

    const classes = classNames(
      "el-tab-list",
      flexDirectionClass(direction),
      paddingClass(padding),
      groupInnerClass({ innerBorder, innerMargin, innerPadding }),
      {
        [`el-tab-list--size-${size}`]: !!size,
        [`el-tab-list--color-${color}`]: !!color,
        [`el-tab-list--theme-${theme}`]: !!theme,
        [`el-tab-list--direction-${direction}`]: !!direction,
      },
      className,
    );

    return <div className={classes}>{children}</div>;
  }
}
